import axios from 'axios';
import { API_BASE_URL } from '../../config';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

const automationsService = {
  getAutomations: () => {
    console.log('Fetching automations');
    return api.get('/automations');
  },
  
  getAutomation: (id) => {
    console.log(`Fetching automation with id ${id}`);
    return api.get(`/automations/${id}`);
  },
  
  createAutomation: (automationData) => {
    console.log('Creating automation:', automationData);
    return api.post('/automations', automationData);
  },
  
  updateAutomation: (id, automationData) => {
    console.log(`Updating automation ${id}:`, automationData);
    return api.put(`/automations/${id}`, automationData);
  },
  
  deleteAutomation: (id) => {
    console.log(`Deleting automation ${id}`);
    return api.delete(`/automations/${id}`);
  },
  
  runAutomation: (id) => {
    console.log(`Running automation ${id}`);
    return api.post(`/automations/${id}/run`);
  },
  
  getAutomationSteps: (automationId) => {
    console.log(`Fetching steps for automation ${automationId}`);
    return api.get(`/automations/${automationId}/steps`);
  },
  
  createAutomationStep: (automationId, stepData) => {
    console.log(`Creating step for automation ${automationId}:`, stepData);
    return api.post(`/automations/${automationId}/steps`, stepData);
  },
  
  updateAutomationStep: (automationId, stepId, stepData) => {
    console.log(`Updating step ${stepId} for automation ${automationId}:`, stepData);
    return api.put(`/automations/${automationId}/steps/${stepId}`, stepData);
  },
  
  deleteAutomationStep: (automationId, stepId) => {
    console.log(`Deleting step ${stepId} for automation ${automationId}`);
    return api.delete(`/automations/${automationId}/steps/${stepId}`);
  },
  
  getFolders: () => {
    console.log('Fetching folders');
    return api.get('/folders');
  },
  
  getStats: () => {
    console.log('Fetching automation statistics');
    return api.get('/automations/stats');
  }
};

export { automationsService };
export default automationsService;
